export default {
    dashboard_delete_chart_title: "Delete Dashboard",
    dashboard_delete_chart_description: "Are you sure you want to delete this Gadget?",
    dashboard_delete_success_message: "The gadget has been deleted",
}